import { render, staticRenderFns } from "./LightBoxDelete.vue?vue&type=template&id=d59476d8"
import script from "./LightBoxDelete?vue&type=script&lang=ts&external"
export * from "./LightBoxDelete?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports